module.exports = __webpack_public_path__ + "static/media/WPILogo.28ec87ac.png";